"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const command_1 = require("../../type/command");
const entity_1 = require("../../type/entity");
const getContentType_1 = require("../getContentType");
const getUnitSetting_1 = tslib_1.__importDefault(require("./getUnitSetting"));
const updateEnrolmentFields_1 = require("./updateEnrolmentFields");
function updateEnrolment(command, content, enrolment) {
    switch (command.type) {
        case command_1.CommandType.ASSIGN_CONTENT:
            {
                const { fromAdmin = false } = command;
                const contentType = getContentType_1.getContentType(content);
                updateEnrolmentFields_1.updateContentStatus(enrolment, content);
                if (command.rootContentId === enrolment.contentId) {
                    updateEnrolmentFields_1.updateDirectEnrolment(command, enrolment);
                }
                updateEnrolmentFields_1.updateEnrolmentInfo(command, enrolment, content);
                updateEnrolmentFields_1.updateParentIds(command, content, enrolment);
                if (contentType === entity_1.ContentType.CHECKPOINT) {
                    const unitSetting = getUnitSetting_1.default(command, content._id);
                    updateEnrolmentFields_1.updateApproverInfoInEnrolment(enrolment, unitSetting);
                }
                updateEnrolmentFields_1.updateDeletedInEnrolment(command, enrolment);
                if (!fromAdmin) {
                    updateEnrolmentFields_1.updateVersionIdOfEnrolment(command.versions || [], content, enrolment);
                }
            }
            break;
        case command_1.CommandType.UPDATE_CONTENT:
        case command_1.CommandType.SWITCH_TO_LATEST_CONTENT:
            {
                updateEnrolmentFields_1.updateVersionIdOfEnrolment(command.versions || [], content, enrolment);
            }
            break;
        default:
            break;
    }
    return enrolment;
}
exports.default = updateEnrolment;
//# sourceMappingURL=updateEnrolment.js.map